module.exports = __webpack_public_path__ + "static/10-d1aad4bc397802e7c4e9f3c67f2a24c5.jpg";